var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddResumeIcon = function SvgAddResumeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#AddResumeIcon_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.9,
    d: "M5.077 12.328c.421.41 2.083 1.5 2.083 2.084m0 0c0 .583-1.662 1.674-2.083 2.083M7.16 14.41H.493"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#AddResumeIcon_svg__b)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.9,
    d: "M8.83 17.33h.227c2.717 0 4.077 0 5.02-.664.268-.189.508-.415.712-.671.707-.888.707-2.167.707-4.725V9.15c0-2.47 0-3.705-.39-4.69-.63-1.587-1.957-2.837-3.642-3.428C10.417.664 9.106.664 6.48.664c-1.498 0-2.248 0-2.847.21-.962.338-1.721 1.053-2.08 1.958-.225.564-.225 1.27-.225 2.68v4.319"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#AddResumeIcon_svg__c)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.9,
    d: "M15.496 8.997A2.777 2.777 0 0 0 12.72 6.22c-.555 0-1.21.097-1.749-.048a1.39 1.39 0 0 1-.982-.983c-.144-.54-.048-1.193-.048-1.748A2.78 2.78 0 0 0 7.163.664"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "AddResumeIcon_svg__a",
    x1: 0.503,
    x2: 6.373,
    y1: 12.027,
    y2: 12.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0085FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88C4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AddResumeIcon_svg__b",
    x1: 1.349,
    x2: 13.999,
    y1: -0.539,
    y2: 0.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0085FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88C4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AddResumeIcon_svg__c",
    x1: 7.174,
    x2: 14.599,
    y1: 0.063,
    y2: 0.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0085FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88C4FC"
  })))));
};
export default SvgAddResumeIcon;